import { render, staticRenderFns } from "./PCMenu.vue?vue&type=template&id=cd6a2e2c&scoped=true&"
import script from "./PCMenu.vue?vue&type=script&lang=ts&"
export * from "./PCMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PCMenu.vue?vue&type=style&index=0&id=cd6a2e2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6a2e2c",
  null
  
)

export default component.exports